{{#if useLabel}}
	<label for="{{inputId}}">{{labelText}}</label>
{{/if}}
{{#if useBuiltInTarget}}
	<input type="text" id="{{inputId}}" class="date-input form-control" name="date" placeholder="{{placeholder}}" aria-describedby="errors-for-{{inputId}}" />
{{/if}}
{{icon "calendar"}}
<span class="date-error help-block" id="errors-for-{{inputId}}"></span>